// Local fallback images (also served via Catalyst Web Hosting as static files)
export const hanumanJi = process.env.PUBLIC_URL + '/assets/hanuman-ji.webp';

// Map of peeth_id (1–51) → Stratus CDN image URL (set via Admin panel after upload)
export const peethImages = {};
